import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import emojiMap from 'simple-emoji-map';
const m = window.m;
const translationPrefix = 'clarkwinkelmann-status.forum.modal.';
export default class StatusModal extends Modal {
  className() {
    return 'ClarkWinkelmannStatusModal';
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.dirty = false;
    this.loading = false;
    this.emoji = this.attrs.user.attribute('clarkwinkelmannStatusEmoji') || '';
    this.text = this.attrs.user.attribute('clarkwinkelmannStatusText') || '';
    this.emojiPickOptions = {};
    Object.keys(emojiMap).forEach(emoji => {
      let emojiName = emojiMap[emoji][0];
      if (app.forum.attribute('clarkwinkelmannStatusOnlyCountries')) {
        if (emojiName.indexOf('flag_') !== 0) {
          return;
        }
        emojiName = emojiName.replace('flag_', '').toUpperCase();
      }
      this.emojiPickOptions[emoji] = `${emojiName} ${emoji}`;
    });
  }
  title() {
    return app.translator.trans(`${translationPrefix}title`);
  }
  content() {
    return m('.Modal-body', [m('.ClarkWinkelmannStatusForm', [m('.Form-group', [m(Select, {
      options: this.emojiPickOptions,
      value: this.emoji,
      onchange: value => {
        this.emoji = value;
        this.dirty = true;
      }
    })]), app.forum.attribute('clarkwinkelmannStatusEnableText') ? m('.Form-group', [m('input.FormControl', {
      disabled: this.loading,
      type: 'text',
      defaultValue: this.text,
      oninput: event => {
        this.text = event.target.value;
        this.dirty = true;
      },
      placeholder: app.translator.trans(`${translationPrefix}text-placeholder`)
    })]) : null]), m('.Form-group.ClarkWinkelmannStatusActions', [m(Button, {
      disabled: !this.dirty,
      loading: this.loading,
      className: 'Button Button--primary',
      type: 'button',
      onclick: event => this.onsubmit(event)
    }, app.translator.trans(`${translationPrefix}submit`)), ' ', m(Button, {
      disabled: !this.attrs.user.attribute('clarkwinkelmannStatusEmoji') && !this.attrs.user.attribute('clarkwinkelmannStatusText'),
      className: 'Button',
      onclick: () => this.clearStatus()
    }, app.translator.trans(`${translationPrefix}clear`))])]);
  }
  clearStatus() {
    this.loading = true;
    this.attrs.user.save({
      clarkwinkelmannStatusEmoji: '',
      clarkwinkelmannStatusText: ''
    }).then(() => {
      this.loading = false;
      this.dirty = false;
      app.modal.close();
    }).catch(error => {
      this.loading = false;
      throw error;
    });
  }
  onsubmit(event) {
    event.preventDefault();
    this.loading = true;
    this.attrs.user.save({
      clarkwinkelmannStatusEmoji: this.emoji || '',
      clarkwinkelmannStatusText: this.text || ''
    }).then(() => {
      this.loading = false;
      this.dirty = false;
      app.modal.close();
    }).catch(error => {
      this.loading = false;
      throw error;
    });
  }
}
flarum.reg.add('kojonos-status', 'forum/components/StatusModal', StatusModal);